import type { Dispatch, SetStateAction } from 'react';

import { Button } from 'antd';

import type { ITest } from '@/api/endpoints/schools/schoolSelectionPanel';
import { ReservedUserCard } from '@/pages/(publicPages)/(schools)/(schoolSelectionPanel)/TestingTab/(pages)/_components/ReservedUsersModal/_components/ReservedUserCard/ReservedUserCard';
import { toggleSetItem } from '@/shared/helpers';

import styles from './ReservedUsersCardList.module.scss';

interface IProps {
  reservedTestingData: ITest[];
  reservedUsersIds: Set<number>;
  setReservedUsersIds: Dispatch<SetStateAction<Set<number>>>;
}

export const ReservedUsersCardList = ({ reservedTestingData, reservedUsersIds, setReservedUsersIds }: IProps) => {
  const isMajorityUnselected =
    reservedTestingData.length - reservedUsersIds.size > Math.floor(reservedTestingData.length / 2);

  const toggleReservedUserId = (id: number) => {
    setReservedUsersIds((prev) => toggleSetItem(prev, id));
  };

  return (
    <div className={styles.wrapper}>
      <Button
        type="primary"
        onClick={() =>
          setReservedUsersIds(isMajorityUnselected ? new Set(reservedTestingData.map(({ id }) => id)) : new Set())
        }
      >
        {isMajorityUnselected ? 'Выбрать' : 'Снять'} всех
      </Button>
      <div className={styles['scrolled-list']}>
        {reservedTestingData.map(({ id, user }) => (
          <ReservedUserCard
            key={id}
            id={id}
            user={user}
            checked={reservedUsersIds.has(id)}
            toggleReservedUserId={toggleReservedUserId}
          />
        ))}
      </div>
    </div>
  );
};
